<template>
    <div class="dispatch computilityPage">
        <MyHeader :showText="true" title="协 鑫 智 算 算 力 调 度 平 台" />
        <!-- <MyHeader title="协 鑫 智 算（苏 州）中 心" /> -->
        <div class="page-left">
            <Part1 />
            <!-- <Part2 /> -->
            <!-- <Part3 /> -->
        </div>
        <div class="page-center">
            <MyCenter />
        </div>
        <div class="page-right">
            <Part4 />
            <Part5 />
            <Part6 />
        </div>
    </div>
</template>

<script>
import MyHeader from './../../components/myHeader.vue'
import MyCenter from './center.vue'
import Part1 from './../../components/overviewCom/part-1.vue'
import Part2 from './../../components/overviewCom/part-2.vue'
import Part3 from './../../components/overviewCom/part-3.vue'
import Part4 from './../../components/overviewCom/part-5.vue'
import Part5 from './../../components/overviewCom/part-4.vue'
import Part6 from './../../components/overviewCom/part-6.vue'
export default {
    components: {
        MyHeader,
        MyCenter,
        Part1,
        Part2,
        Part3,
        Part4,
        Part5,
        Part6,
    }
}
</script>

<style lang="scss" scoped>
@import './../../components/comm.scss';
</style>